<template>
    <div v-if="sessionId" class="discounts-page">
        <el-row :gutter="20">
            <el-col :sm="12" :md="12" :lg="12" :xl="8">
                <el-card class="m-b-20">
                    <div slot="header">
                        <h2>Поиск парковочной карты</h2>
                    </div>
                    <el-input v-model="cardId" placeholder="Введите номер карты"></el-input>
                    <el-button class="m-t-20" icon="icon-search" type="primary" @click="searchCard">
                        Найти карту
                    </el-button>
                </el-card>
            </el-col>
            <el-col v-if="params" :sm="24" :md="24" :lg="12" :xl="16">
                <el-card>
                    <div slot="header" class="d-flex flex-header">
                        <el-row :gutter="0" class="w-100">
                            <el-col :xs="24" :sm="24" :md="12">
                                <h2>Параметры карты</h2>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" align="right">
                                <el-select v-model="discountId" placeholder="Применить скидку" class="m-r-20">
                                    <el-option
                                        v-for="item in discounts"
                                        :key="item.Id"
                                        :label="item.Name"
                                        :value="item.Id">
                                    </el-option>
                                </el-select>
                                <el-button type="primary" @click="setDiscount">Применить</el-button>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="params">
                        <!-- eslint-disable-next-line -->
                        <div v-if="paramsDict[key]" v-for="(param, key) in params" :key="key">
                            <div>
                                <span>{{paramsDict[key]}}:</span>

                                <div v-if="key === 'Total'">
                                    {{ (param / 100).toFixed(2) }} &#8381;
                                    <span v-if="discountId">
                                        (со скидкой: {{ calcNewTotal(param) }} &#8381;)
                                    </span>
                                </div>
                                <div v-else-if="!isNaN(param) && key !== 'CardId'">
                                    {{ (param / 100).toFixed(2) }} &#8381;
                                </div>
                                <div v-else-if="key === 'EntranceTime' || key === 'PaymentTime' || key === 'ToExitTime'">
                                    {{ param | date}}
                                </div>
                                <div v-else>
                                    {{param}}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
    <h2 v-else>
        Нет доступа к модулю скидок. Проверьте, что он подключен в файле конфигурации.
    </h2>
</template>

<script>
export default {
    data () {
        return {
            cardId: '',
            sessionId: sessionStorage.getItem('sessionId'),
            user: sessionStorage.getItem('username'),
            hardwareId: null,
            version: '1.2',
            params: null,
            paramsDict: {
                "CardId": "Номер карты",
                "EntranceTime": "Время въезда",
                "ToExitTime": "Выезд до",
                "Paid": "Оплачено ранее",
                "Debt": "Задолженность",
                "Discount": "Скидка (ранее)",
                "Total": "Итого",
                "PaymentTime": "Оплачено"
            },
            discounts: [],
            discountId: null
        }
    },
    methods: {
        calcNewTotal (total) {
            if (!this.discountId) return ''
            if (this.discountId === 1) return 0

            let discountAmount = parseInt(this.discounts.find(x => x.Id === this.discountId).Amount)
            let newTotal = (total - discountAmount) / 100
            return (newTotal < 0 ? 0 : newTotal).toFixed(2)
        },
        searchCard () {
            this.loading = true

            let body = {
                "Name": "GetInvoice",
                "Version": this.version,
                "HardwareId": this.hardwareId,
                "User": this.user,
                "CardId": this.cardId,
                "SessionId": this.sessionId
            }

            this.$api.Discounts.getInvoice(body).then(response => {
                if (response.RequestResult === 0) {
                    this.params = response.PaymentDocument
                    this.getDicounts()
                }
                else {
                    this.params = null
                    this.$message({ message: response.ErrorInfo, type: 'error' })
                }

                this.loading = false
            }).catch (() => {
                this.params = null
                this.loading = false
            })
        },
        getDicounts () {
            let body = {
                "Name": "GetDiscounts",
                "Version": this.version,
                "HardwareId": this.hardwareId,
                "User": this.user,
                "SessionId": this.sessionId
            }
            this.$api.Discounts.getDiscounts(body).then(response => {
                this.discounts = response.Discounts
            })
        },
        setDiscount () {
            if (!this.discountId) {
                this.$message({ message: 'Скидка не выбрана', type: 'error' })
            }

            let amount = this.discounts.find(x => x.Id === this.discountId).Amount
            if (amount == 0) {
                amount = this.params.Total
            }

            let body = {
                "Name": "DiscountNotification",
                "Version": this.version,
                "HardwareId": this.hardwareId,
                "User": this.user,
                "SessionId": this.sessionId,
                "CardId": this.cardId,
                "DiscountId": this.discountId,
                "Amount": amount
            }

            this.$api.Discounts.setDiscount(body).then(response => {
                if (response.RequestResult === 0) {
                    this.$message({ message: 'Скидка предоставлена', type: 'success', res: response })
                    this.searchCard()
                }
                else {
                    this.$message({ message: response.ErrorInfo, type: 'error' })
                }
            }).catch (() => {
                this.$message({ message: 'Ошибка предоставления скидки', type: 'error' })
            })
        }
    }
}
</script>

<style scoped>

</style>
